import React from 'react';
import PropTypes from 'prop-types';
import BootstrapCard from "../bootstrapCard/BootstrapCard";
import FileDrop from '../fileDrop/FileDrop';
import UploadFilesProgress from "../fileDrop/c/uploadFilesProgress/UploadFilesProgressConnector";
import './dataFilePanel.scss';
import { primaryBlue } from '../../../theme/mainColors';

const fileDropStyle = {
  acceptedBorderColor: primaryBlue,
  rejectedBorderColor: 'red',
  width: '100%'
};

const progressContainerStyle = {
  display: 'flex',
  flexDirection: 'column'
};

class DataFileUploadPanel extends React.Component {
  handleFileUploadComplete = () => this.props.onFileUploadComplete();

  render() {
    const {
      acceptedFiles,
      additionalInformation,
      fullWidth,
      rejectedFiles,
      uploadStep,
      url,
      onDropFiles,
      disabled,
      loading,
      title,
      margin
    } = this.props;
    return (
      <BootstrapCard 
        title={ title }
        width={ 600 }
        contentStyle={ { padding: 5 } }
        fullWidth={ fullWidth }
        disabled={ disabled }
        loading={ loading }
        margin={ margin }
      >
        <div className="dragAndDropModal__container">
          {
            uploadStep === 'upload' &&
            <FileDrop
              style={ fileDropStyle }
              acceptedFiles={ acceptedFiles }
              rejectedFiles={ rejectedFiles }
              onDropFiles={ onDropFiles }
              acceptedTypes={ ['csv', 'excel'] }
            />
          }
          {
            uploadStep === 'progress' &&
            <div id="progress-container" style={ progressContainerStyle }>
              <UploadFilesProgress
                url={ url }
                acceptedFiles={ acceptedFiles }
                additionalInformation={ additionalInformation }
                message="We&apos;re processing your files. You can stay on this page until it finishes, or leave and check the imports page for results later"
                onComplete={ this.handleFileUploadComplete }
              />
            </div>
          }
        </div>
      </BootstrapCard>
    );
  }
}

DataFileUploadPanel.propTypes = {
  acceptedFiles: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  additionalInformation: PropTypes.object,
  fullWidth: PropTypes.bool,
  uploadStep: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  rejectedFiles: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onDropFiles: PropTypes.func.isRequired,
  onFileUploadComplete: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  title: PropTypes.string,
  margin: PropTypes.string
};

DataFileUploadPanel.defaultProps = {
  fullWidth: true,
  additionalInformation: {},
  onFileUploadComplete: () => null,
  disabled: false,
  loading: false,
  title: `Select Data File`,
  margin: `15px 0`
};

export default DataFileUploadPanel;



// WEBPACK FOOTER //
// ./src/shared/components/dataFilePanel/DataFilePanel.js